import { MastheadLink, MastheadLinkList } from 'lib/sanity/types';
import { Vertical } from 'utils/vertical/vertical';
import { VerticalUnsupportedError } from 'utils/vertical/vertical-unsupported-error';

export const isString = (value: unknown): value is string => value !== null && typeof value === 'string';

export const assertIsString = (value: unknown): string => {
  if (isString(value)) {
    return value;
  }

  throw new TypeError('Value is not string');
};

export const isNumber = (value: unknown): value is number =>
  value !== null && typeof value !== 'undefined' && !isNaN(Number(value));

export const assertIsNumber = (value: unknown): number => {
  if (isNumber(value)) {
    return Number(value);
  }

  throw new TypeError('Value is not number');
};

export const isVertical = (value: unknown): value is Vertical =>
  typeof value === 'string' && Object.values(Vertical).includes(value as Vertical);

export const assertIsVertical = (value: unknown): Vertical => {
  if (isVertical(value)) {
    return value;
  }
  throw new VerticalUnsupportedError(`Input "${value}" is not a valid vertical`);
};

export const isMastheadLinkList = (value: MastheadLinkList | MastheadLink): value is MastheadLinkList =>
  'entries' in value;

export const isMastheadLink = (value: MastheadLinkList | MastheadLink): value is MastheadLink =>
  'entries' in value === false;
